// combatpro/views/WaveEncountersView.js
//
// Combat PRO - dedicated Wave Encounter page (spec 12). Create a complete multi-stage
// battle automatically from high-level presets. It reuses the shared
// GeneratedFamilySection (same generator components/state/actions as the dashboard
// Wave section); Combat PRO decides monsters, counts, distribution, groups and the
// event/trigger sequence. No optional chaining. No em dash.

import React from 'react';
import GeneratedFamilySection from '../runtime/GeneratedFamilySection';

function WaveEncountersView() {
  return (
    <div className="vi-view cp-family-page" id="view-wave-encounters">
      <div className="cp-family-head">
        <div>
          <h2>{'\ud83c\udf0a Wave Encounters'}</h2>
          <div className="cp-family-helper">A complete staged battle in seconds. Choose level, difficulty, total monsters, wave count and style; Combat PRO builds the waves, combat groups and entry triggers. Every change saves automatically.</div>
        </div>
      </div>
      <GeneratedFamilySection family="wave" />
    </div>
  );
}

export default WaveEncountersView;
